import { PaymentRequestStatus } from "./payment-request-status.model";

export class PaymentRequestDetail {
  PaymentRequestId: number;
  Amount: number;
  AmountCurrency: string;
  RemittanceInformation: string;
  CreatedAt: Date;
  LastChangedAt: Date;
  CompletedAt: Date;
  ExpirationDate: Date;
  DebtorName: string;
  Status: PaymentRequestStatus;

  constructor() {
    this.PaymentRequestId = null;
    this.Amount = null;
    this.AmountCurrency = null;
    this.RemittanceInformation = null;
    this.CreatedAt = null;
    this.LastChangedAt = null;
    this.CompletedAt = null;
    this.ExpirationDate = null;
    this.DebtorName = null;
    this.Status = new PaymentRequestStatus();
  }
}
